import React from 'react'
import { Link } from 'react-router-dom'
import BadgeUI from '../../../widgets/output/BadgeUI'
import SelectUI from '../../../widgets/input/SelectUI'
import CardUI from '../../../widgets/layout/CardUI'
import CustomerInvoicesDisburseModalSF from './CustomerInvoicesDisburseModalSF'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import CustomerInvoicesCreateModalSF from './CustomerInvoicesCreateModalSF'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import InterestCollectionModalSF from './InterestCollectionModalSF'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import CustomerInvoicesNavUI from './CustomerInvoicesNavUI'
import RFFeePaymentModalSF from './RFFeePaymentModalSF'
import InterestCollection2ModalSF from './InterestCollection2ModalSF'
import './ReceivableFinancingPage.css'

const ReceivableFinancingPageUI = ({ context, account, invoiceList, customerList, onRefreshClick,
  createMode, onCreateClick, onCancelCreateInvoice,
  disburseMode, selectedCustomerInvoiceId, onDisburseClick, onDisburseCancel,
  onInterestPaymentClick, interestPaymentSubmitted, onInterestPaymentCancel,
  selectedCustomerId, customer, filteredCustomerList, onCustomerChange,
  onUtilizeClick, utilizeMode, onUtilizeClickCancel, customerInvoiceList,
  onFeePaymentClick, onFeePaymentClickCancel, feePaymentMode
}) =>
  <SuperUserAccountPageUI context={context} className='pg_su_rf' backLink='/su/accounts'
    headerText={account && account.accountName} centered={!account || !customerList}
    account={account} page='rf'
  >
    {
      (!account || !customerList) &&
      <SpinnerComponentUI />
    }
    {
      account && customerList &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <div className='g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              {/* <IconButtonUI icon='icon-plus' onClick={onCreateClick} /> */}
              <span className='g_m_left_100 g_large'><b>Receivable Financing</b></span>
            </div>
          }
          right={
            <span />
          }
        />
        <CustomerInvoicesNavUI context={context} account={account} page='rf' />

        <SelectUI selectedKey={selectedCustomerId} optionList={filteredCustomerList} onChange={onCustomerChange} placeholder='Customer' />

        {
          invoiceList &&
          <InvoiceTableUI context={context} account={account} customer={customer} invoiceList={invoiceList} onDisburseClick={onDisburseClick}
            onInterestPaymentClick={onInterestPaymentClick} onUtilizeClick={onUtilizeClick} selectedCustomerId={selectedCustomerId}
            onFeePaymentClick={onFeePaymentClick} />
        }
      </div>
    }
    <CustomerInvoicesCreateModalSF context={context} account={account} createMode={createMode}
      onCancelCreate={onCancelCreateInvoice} onRefreshClick={onRefreshClick} customerList={customerList} />

    <CustomerInvoicesDisburseModalSF context={context} account={account} updateMode={disburseMode}
      onCancelCreate={onDisburseCancel} onRefreshClick={onRefreshClick} selectedCustomerInvoiceId={selectedCustomerInvoiceId} />

    <InterestCollectionModalSF context={context} selectedCustomerId={selectedCustomerId} selectedCustomerInvoiceId={selectedCustomerInvoiceId}
      customerInvoiceList={customerInvoiceList} updateMode={utilizeMode} onCancelClick={onUtilizeClickCancel} onRefreshClick={onRefreshClick}
    />

    <InterestCollection2ModalSF context={context} account={account} updateMode={interestPaymentSubmitted}
      onCancelClick={onInterestPaymentCancel} onRefreshClick={onRefreshClick} selectedCustomerInvoiceId={selectedCustomerInvoiceId} />

    <RFFeePaymentModalSF context={context} account={account} selectedCustomerInvoiceId={selectedCustomerInvoiceId}
      onRefreshClick={onRefreshClick} updateMode={feePaymentMode} onCancelClick={onFeePaymentClickCancel} />

  </SuperUserAccountPageUI>

const InvoiceTableUI = ({ context, account, customer, invoiceList, onDisburseClick, onInterestPaymentClick,
  onUtilizeClick, onFeePaymentClick, selectedCustomerId }) =>
  <CardUI>
    <div className='g_flex_v'>
      <span>Interest rate: {account.rfInterestRate}</span>
      <span>Total unutilized: {customer && customer.unutilizedAmountF1}</span>
    </div>
    <table className='g_m_top_50 table'>
      <thead>
        <tr >
          <th>Invoice Status</th>
          <th>Invoice Amount</th>
          <th>Disbursment Amount</th>
          <th>Invoice Processing Fee</th>
          <th>Allocation of Collection</th>
          <th>Interest Payment to Clime</th>
          <th>Margin Money Returned</th>
          <th>Returned to Clime</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {
          invoiceList.map((invoice, i) =>
            <tr key={i}>
              <InvoiceUI invoice={invoice} align='left' />
              <ValueUI value={invoice.invoiceAmountF5} label2='Invoice Date' value2={invoice.invoiceDateF1} />
              <DisburseUI invoice={invoice} onDisburseClick={onDisburseClick} />
              <FeeUI context={context} invoice={invoice} onFeePaymentClick={onFeePaymentClick} />
              <CollectionUI invoice={invoice} onUtilizeClick={onUtilizeClick} selectedCustomerId={selectedCustomerId} />
              <InterestUI context={context} invoice={invoice} onInterestPaymentClick={onInterestPaymentClick} />
              <ValueUI value={invoice.marginMoney < 0 ? `(${invoice.marginMoneyF5})` : invoice.marginMoneyF5} label2='todo' value2={''} />
            </tr>
          )
        }
      </tbody>
    </table>
  </CardUI>

const ValueUI = ({ value, label2, value2, align }) =>
  <td className={align === 'left' ? '' : 'g_text_right'}>
    <span className='g_flex_v'>
      {value}
      {
        value2 &&
        <span className='g_muted g_tiny g_no_wrap_2 g_m_top_50'>{label2}</span>
      }
      {
        value2 &&
        <span className='g_no_wrap_2'>{value2}</span>
      }
    </span>
  </td>

const InvoiceUI = ({ invoice, align }) =>
  <td className={align === 'left' ? '' : 'g_text_right'}>
    <span className='g_flex_v'>
      {invoice.invoiceName}
      {
        invoice.invoiceNumber &&
        <span className='g_muted g_tiny g_no_wrap_2 g_m_top_50'>Invoice No.</span>
      }
      {
        invoice.invoiceNumber &&
        <span className='g_no_wrap_2'>{invoice.invoiceNumber ? invoice.invoiceNumber : 'NA'}</span>
      }
      <BadgeUI className='g_m_top_25' label={invoice.status} />
    </span>
  </td>

const DisburseUI = ({ align, invoice, onDisburseClick }) =>
  <td className={align === 'left' ? '' : 'g_text_right'}>
    <span className='g_flex_v'>
      {invoice.disbursedAmountF5}
      {
        invoice.disbursedDateF1 &&
        <span className='g_muted g_tiny g_no_wrap_2 g_m_top_50'>Disbursed</span>
      }
      {
        <span className='g_no_wrap_2'>{invoice.disbursedDateF1 ? invoice.disbursedDateF1 : 'Not disbursed'}</span>
      }
      {
        invoice.status !== 'Disbursed' && invoice.status !== 'Paid' &&
        <Link to='#' onClick={onDisburseClick} data-row-id={invoice.customerInvoiceId}>Disburse</Link>
      }
    </span>
  </td>

const FeeUI = ({ context, align, invoice, onFeePaymentClick }) =>
  <td className={align === 'left' ? '' : 'g_text_right'}>
    <span className='g_flex_v'>
      {invoice.processingFee && invoice.processingFee.amountWithTaxF2}
      {
        invoice.processingFee.initiateDateF1 && invoice.procFeeStatus === 'pending' &&
        <>
          <span className='g_muted g_tiny g_no_wrap_2 g_m_top_50'>Initiated Date</span>
          <span className='g_no_wrap_2'>{invoice.processingFee.initiateDateF1}</span>
        </>
      }
      {
        invoice.processingFee.paidDateF1 && invoice.procFeeStatus === 'paid' &&
        <>
          <span className='g_muted g_tiny g_no_wrap_2 g_m_top_50'>Paid Date</span>
          <span className='g_no_wrap_2'>{invoice.processingFee.paidDateF1}</span>
        </>
      }
      <span className='g_no_wrap_2'>{invoice.procFeeStatus}</span>
      {
        invoice.status === 'Disbursed' && invoice.procFeeStatus === 'unpaid' && context.permissions.includes('su_finance') &&
        <Link to='#' onClick={onFeePaymentClick} data-row-id={invoice.customerInvoiceId}>Pay fee</Link>
      }
    </span>
  </td >

const InterestUI = ({ context, align, invoice, onInterestPaymentClick }) =>
  <td className={align === 'left' ? '' : 'g_text_right'}>
    {
      invoice.interestPaymentList.map((interest, i) =>
        <span className='g_flex_v' key={i}>
          {
            interest.initiateDateF1 && !interest.paidDateF1 &&
            <>
              <span className='g_muted g_tiny g_no_wrap_2 g_m_top_50'>Initiated</span>
              <span className='g_flex_h'>
                <span className='g_no_wrap_2'>{interest.initiateDateF1}</span>
                {interest.amountWithTaxF2}
              </span>
            </>
          }
          {
            interest.paidDateF1 &&
            <span className='g_flex_h'>
              <span className='g_no_wrap_2'>{interest.paidDateF1}</span>
              {interest.amountWithTaxF2}
            </span>
          }
        </span>
      )
    }
    {
      invoice.status === 'Disbursed' && context.permissions.includes('su_finance') &&
      <Link to='#' className='g_no_wrap_2' onClick={onInterestPaymentClick} data-row-id={invoice.customerInvoiceId}>Pay month-end interest</Link>
    }
  </td>

const CollectionUI = ({ align, invoice, onUtilizeClick, selectedCustomerId }) =>
  <td className={align === 'left' ? '' : 'g_text_right'}>
    {
      invoice.collectionList.map((collection, i) =>
        <span className='g_flex_v' key={i}>
          {
            collection.dateF1 &&
            <>
              <span className='g_flex_h'>
                <span className='g_no_wrap_2'>{collection.dateF1}</span>
                {collection.amountF5}
              </span>
            </>
          }
        </span>
      )
    }
    {
      invoice.status === 'Disbursed' &&
      <Link to='#' className='g_no_wrap_2' onClick={onUtilizeClick} data-id={selectedCustomerId} data-row-id={invoice.customerInvoiceId}>
        Utilize customer's unutilized funds</Link>
    }
  </td>

export default ReceivableFinancingPageUI
